import React from 'react';
import { Link } from 'react-router-dom';

class ChefCounts extends React.Component {
  state = {
    activeTab: 'today'
  };

  render() {
    const { today, yesterday, this_week, last_week, total } = this.props.counts;
    return (
      <div className="cms__section">
        <div className="cms__bar cms__section-head">
          <div className="cms__bar-left">
            <h3 className="h3">Chefs</h3>
          </div>
          <div className="cms__bar-right">
            <Link to="/admin/chefs" className="a--blue" data-test="view-chefs">
              View {total} Chefs
            </Link>
          </div>
        </div>
        <div className="cms__section-body cms__section-body--no-pad">
          <div className="tabs tabs--flex">
            <div
              className={this.getTabClasses('today')}
              onClick={() => this.handleTabClick('today')}
            >
              Today
            </div>
            <div
              className={this.getTabClasses('week')}
              onClick={() => this.handleTabClick('week')}
            >
              This Week
            </div>
          </div>

          <div className="tab__content">
            {this.isActiveTab('today') && (
              <CountBlock
                type="today"
                thisBlock={{ count: today }}
                lastBlock={{ count: yesterday }}
              />
            )}

            {this.isActiveTab('week') && (
              <CountBlock
                type="week"
                thisBlock={{ count: this_week }}
                lastBlock={{ count: last_week }}
              />
            )}
          </div>
        </div>
      </div>
    );
  }

  handleTabClick = activeTab => this.setState({ activeTab });

  isActiveTab = activeTab => activeTab === this.state.activeTab;

  getTabClasses = tab => {
    const classes = ['tab', 'tab--flex'];
    if (this.isActiveTab(tab)) classes.push('active');
    return classes.join(' ');
  };
}
export default ChefCounts;

const CountBlock = ({ type, thisBlock, lastBlock }) => {
  const typeLabel = type === 'today' ? 'Yesterday' : 'Last Week';
  const lastCounts = lastBlock && (
    <p className="dash-counts__last">{`${typeLabel}: ${
      lastBlock.count
    } Booked Chefs`}</p>
  );
  return (
    <div className="count-block">
      {thisBlock && (
        <div className="dash-counts">
          <div className="dash-count">
            <div className="dash-count__count">{thisBlock.count}</div>
            <div className="dash-count__label">Booked Chefs</div>
          </div>
        </div>
      )}
      {lastCounts}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/dashboard/ChefCounts.js